import {
  Avatar,
  Box,
  Center,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import { IUserProfile } from "../../models/admin/user.model";
import adminHelpers from "../../services/admin/admin.service";
import Adminroutes from "./routes";

const AdminTrainers = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [allTrainers, setAllTrainers] = useState<IUserProfile[]>([]);
  const [fileteredTrainers, setFilteredTrainers] = useState<IUserProfile[]>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);

  useEffect(() => {
    adminHelpers.getTrainers().then((res) => {
      
      const approvedtrainers = res.data.filter(
        (each) => each.approval_status == "Approved"
      );
      setAllTrainers(approvedtrainers);
      setFilteredTrainers(approvedtrainers);
      setLoading(false);
    });
    const maingender = [
      {
        id: "1",
        title: "Technical",
      },
      {
        id: "2",
        title: "Non-Technical",
      },
    ];
    setGender(maingender);
  }, []);
  const viewTrainer = async (trainer_id: string) => {
    navigate(Adminroutes.ReviewTrainerLink(trainer_id));
  };
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    
    if (!searchTerm) {
      setFilteredTrainers(allTrainers);
    } else {
      if (allTrainers) {
        const filtered = allTrainers.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredTrainers(filtered);
        
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const viewTrainee = async (trainee_id: string) => {
    navigate(Adminroutes.ReviewTraineeLink(trainee_id));
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex           minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}>
                <Box
            width={["4rem", "4rem", "4rem", "25%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

          <Box width="100%">
            <AdminDashboardHeader />
            <Box
                  pt="30px"
                  pb="40px"
                  px={["20px", "30px"]}
                  width={"100%"}
                  bg="#F9F8F8"
                  height={"100%"}
                  minHeight={"95vh"}
                  maxHeight={"95vh"}
                  overflowY={"scroll"}
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Trainers
                </Box>

                {/* <HStack>
                                <Menu>
                                    <MenuButton
                                        as={Button}
                                        rightIcon={<BsChevronDown />}
                                        bg='white'
                                        color='#616161'
                                        variant={"outline"}
                                        size="sm"
                                        fontSize={13}
                                        width="106px"
                                        border='1px solid'
                                        borderColor='#9E9E9E'
                                    >
                                        2022/2023
                                    </MenuButton>
                                    <MenuList fontSize={12}>
                                        <MenuItem>2022/2023</MenuItem>

                                        <MenuItem>2021/2022</MenuItem>
                                        <MenuItem> 2020/2021</MenuItem>
                                        <MenuItem>2019/2020</MenuItem>

                                    </MenuList>
                                </Menu>

                            </HStack> */}
              </Flex>
              <Flex py="15px" justifyContent="">
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width={["100%", "100%", "50%", "30%"]}
                >
                  <Input
                    height="40px"
                    onChange={(e) => handleSearchChange(e)}
                    placeholder="Search trainers by name"
                    fontSize={12}
                    size="sm"
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>

               
              </Flex>
              <Box width="100%">
                <TableContainer>
                  <Table variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Trainer</Th>
                        <Th textTransform="none">Trainer ID</Th>
                        <Th textTransform="none">Email Address</Th>
                        <Th textTransform="none"> Area of speciality</Th>
                        <Th textTransform="none">Options</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {fileteredTrainers.map((each) => (
                        <Tr bg="white" key={each.id}>
                          <Td>
                            <HStack spacing="10px">
                              <Avatar name={each.name} size="sm" />
                              <Text
                                fontWeight="600"
                                fontSize="16px"
                                color="#616161"
                              >
                                {each.name}
                                <br></br>
                                {/* Mechanical Engineering */}
                              </Text>
                            </HStack>
                          </Td>
                          <Td>
                            {" "}
                            <Text>TNR{each.code}</Text>
                          </Td>
                          <Td>
                            <Text>{each.email}</Text>
                          </Td>
                          <Td>
                            {" "}
                            <Flex>
                              {each.specialities
                                .slice(0, 1)
                                .map((special, indexx) => (
                                  <Text key={indexx}> {special.id}...</Text>
                                ))}
                            </Flex>
                          </Td>

                          <Td>
                            <HStack>
                              <Center
                                border="1px solid"
                                borderRadius="10px"
                                onClick={() => {
                                  viewTrainer(each.uuid);
                                }}
                                borderColor="#E5E5E5"
                                width="30px"
                                height="30px"
                              >
                                <RiEyeLine />
                              </Center>
                              {/* <Center border='1px solid' borderRadius='10px' borderColor='#E5E5E5' width='30px' height='30px'>

                                                                <HiOutlinePencil />

                                                            </Center> */}
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AdminTrainers;
